var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3968_2379)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.446289,
    y: 0.294922,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#19181D"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3968_2379)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.40007 9.51513V18.291H6.6071V9.51513H9.40007ZM9.5778 6.80532C9.58344 7.23629 9.44097 7.59642 9.15039 7.8857C8.85981 8.17498 8.47754 8.31963 8.00358 8.31963H7.98665C7.52398 8.31963 7.15158 8.17498 6.86947 7.8857C6.58735 7.59642 6.44629 7.23629 6.44629 6.80532C6.44629 6.36845 6.59158 6.00684 6.88216 5.72051C7.17274 5.43418 7.55219 5.29102 8.02051 5.29102C8.48882 5.29102 8.86404 5.43418 9.14616 5.72051C9.42828 6.00684 9.57216 6.36845 9.5778 6.80532ZM19.4463 13.261V18.291H16.6618V13.5976C16.6618 12.9777 16.5475 12.4921 16.319 12.1408C16.0905 11.7895 15.7336 11.6139 15.2484 11.6139C14.8929 11.6139 14.5953 11.7157 14.3555 11.9194C14.1157 12.1231 13.9365 12.3755 13.818 12.6766C13.756 12.8537 13.7249 13.0928 13.7249 13.3939V18.291H10.9404C10.9517 15.9354 10.9574 14.0256 10.9574 12.5615C10.9574 11.0973 10.9545 10.2236 10.9489 9.9402L10.9404 9.51513H13.7249V10.7903H13.708C13.8209 10.6014 13.9365 10.4361 14.055 10.2944C14.1735 10.1527 14.3329 9.99924 14.5332 9.83393C14.7335 9.66863 14.9789 9.54022 15.2695 9.44871C15.5601 9.35721 15.8831 9.31145 16.2386 9.31145C17.2035 9.31145 17.9793 9.64649 18.5661 10.3166C19.1529 10.9866 19.4463 11.9681 19.4463 13.261Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3968_2379"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.446289,
    y: 0.294922,
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3968_2379"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(5.44629 5.29102)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.47feb5b542167993e40136e91fdbf381.svg";
export { ForwardRef as ReactComponent };